import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
// import "./prop1side.css";
import { Modal } from "react-bootstrap";
import { PremiumbreakupHealth } from "./PremiumBreakup";
function Prop1sideHealth() {
  const QuickQuotes = useSelector((state) => state?.vehicledetail?.quickquotes);
  const SelectedQQ = useSelector((state) => state?.common?.selectedQuote);
  const QuotePost = useSelector((state) => state?.healthdetail?.QuickQuotePost);
  const [Quote, setQuote] = useState(QuickQuotes);
  const [loading, setLoading] = useState(false);
  const state = useSelector((store) => store.addressdetail.choice);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (state) {
      setLoading(true);
    }
  }, []);

  const handlePremium = () => {
    setShow(true);
  };
  return loading ? (
    <div>
      <h1>Loading....</h1>
    </div>
  ) : (
    <>
      <div className="prop1parent-skb">
        <div className="prop1parent-skb-child">
          <div>
            <img src={SelectedQQ?.logo} alt=""></img>
          </div>
        </div>

        <div className="prop1parent-skb-child">
          <div className="proptotalprempay">
            <p className="pd-txt-head">Your Plan Details</p>
            <div className="w-100 d-flex align-items-center border-bottom p-2">
            <div className="w-50">{QuotePost?.PolicyType === 'NONFLOATER' ? 'Self' : 'Family'}</div>
            </div>
            <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-1">
              <div className="w-50">Policy Type:</div>
              <div className="w-50 text-end">
              {QuotePost?.PolicyType === 'NONFLOATER' ? 'Individual' : 'Family'}
              </div>
            </div>
            <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-1">
              <div className="w-50">Plan Type:</div>
              <div className="w-50 text-end">
              Base Health
              </div>
            </div>
            <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-1">
              <div className="w-50">Cover:</div>
              <div className="w-50 text-end">
              {QuotePost?.suminsured === "300000" ? '₹ 3 Lakhs': 
                QuotePost?.suminsured === "500000" ? '₹ 5Lakhs': 
                QuotePost?.suminsured === '750000' ? '₹ 7.5 Lakhs':
                QuotePost?.suminsured === '1000000' ? '₹ 10 Lakhs':
                QuotePost?.suminsured === '1500000' ? '₹ 15 Lakhs': 
                QuotePost?.suminsured === '2000000' ? '₹ 20 Lakhs':
                QuotePost?.suminsured === '2500000' ? '₹ 25 Lakhs':
                QuotePost?.suminsured === '5000000' ? '₹ 50 Lakhs': 
                QuotePost?.suminsured === '7500000' ? '₹ 75 Lakhs':
                QuotePost?.suminsured === '10000000' ? '₹ 1 Crore': ''}
              </div>
            </div>
            <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-1">
              <div className="w-50">Premium:</div>
              <div className="w-50 text-end">
              ₹{" "}{typeof SelectedQQ?.premium?.basePremium === 'string' ? Math.round(parseFloat(SelectedQQ?.premium?.basePremium?.replace(/[^\d.]/g, ""))) : SelectedQQ?.premium?.basePremium}
              </div>
            </div>
            <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-1">
              <div className="w-50">Policy Term:</div>
              <div className="w-50 text-end">
              {QuotePost?.policyPeriod === 1 ? '1 Year' : 
              QuotePost?.policyPeriod === 2 ? '2 Years' : 
              QuotePost?.policyPeriod === 3 ? '3 Years' : ''}
              </div>
            </div>
            <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-1">
              <div className="w-50">GST:</div>
              <div className="w-50 text-end">
              ₹
              {/* {" "}{typeof SelectedQQ?.premium?.basePremium === 'string' ? Math.round(parseFloat(SelectedQQ?.premium?.basePremium?.replace(/[^\d.]/g, ""))) : SelectedQQ?.premium?.basePremium} */}
              </div>
            </div>
            <div className="w-100 d-flex align-items-center justify-content-center border-bottom p-1">
              <div className="w-50">Total Premium (Inc GST):</div>
              <div className="w-50 text-end">
              ₹{" "}{typeof SelectedQQ?.premium?.basePremiumWithTax === 'string' ? Math.round(parseFloat(SelectedQQ?.premium?.basePremiumWithTax?.replace(/[^\d.]/g, ""))) : SelectedQQ?.premium?.basePremiumWithTax}
              </div>
            </div>
            
          </div>
          <div>
          {/* <p
              style={{ color: "blue", cursor: "pointer" }}
              onClick={handlePremium}
            >
              Premium Breakup
            </p> */}
          </div>
        </div>
      </div>
      <Modal
        show={show}
        onHide={() => setShow(false)}
        dialogClassName="modal-90w"
        aria-labelledby="example-custom-modal-styling-title"
        size="lg"
      >
        <PremiumbreakupHealth
          quickQuote={SelectedQQ}
          Addon={SelectedQQ?.coverages?.addons}
        />
      </Modal>
    </>
  );
}

export { Prop1sideHealth };
